import React from 'react';
import PropTypes from 'prop-types';
import { ListTable, GhostIndicator } from 'base-components';

function ghostColumns({ columnSpans }) {
  return columnSpans.map((columnSpan, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <ListTable.Data flex={columnSpan} key={index} modifiers={['flexRow']}>
      <GhostIndicator />
    </ListTable.Data>
  ));
}

function ListRowLoading({ columnSpans }) {
  return (
    <ListTable.Row>
      {ghostColumns({ columnSpans })}
    </ListTable.Row>
  );
}

ListRowLoading.propTypes = {
  columnSpans: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default ListRowLoading;



// WEBPACK FOOTER //
// ./components/_common/ListRowLoading/index.js